import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { IS_DEMO } from '../../constants/env'
import LoadingSpinner from '../../components/LoadingSpinner'

type UserRole = 'admin' | 'customer'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole: UserRole
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, isAuthenticated, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!isAuthenticated) {
    return <Navigate to={IS_DEMO ? '/products' : '/?login=true'} replace />
  }

  if (requiredRole === 'admin' && !user?.is_admin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
